import React, {useEffect, useState} from "react";

import * as AssetsService from "../../api/AssetsService"
import styles from "./MyCardsMenu.module.css"
import AddIcon from '@mui/icons-material/Add';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import {useTranslation} from "react-i18next";

export default function MyProfileMenu(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'myProfileMenu' });
    function getItemStyle(counter) {
        return Object.assign({
            animationDuration: "0.4s",
            animationDelay: counter*0.1 + "s",
        })
    }

    return (
        <>
            <div className={styles.profileMenuContainer}>
                <div
                    className={styles.menuItem}
                    style={getItemStyle(0)}
                    onClick={() => props.setCurrentView("profile")}
                >
                    <AppRegistrationOutlinedIcon/> {t('profile')}
                </div>
                <div
                    className={styles.menuItem}
                    style={getItemStyle(2)}
                    onClick={() => props.setCurrentView("security")}
                >
                    <AppRegistrationOutlinedIcon/> {t('securitySettings')}
                </div>
                <div
                    className={styles.menuItem}
                    style={getItemStyle(4)}
                    onClick={() => props.setCurrentView("game_settings")}
                >
                    <AppRegistrationOutlinedIcon/> {t('gameSetup')}
                </div>
            </div>
        </>
    )
}


